import { render, staticRenderFns } from "./rubric_from_template.vue?vue&type=template&id=225c3c31&scoped=true&"
import script from "./rubric_from_template.vue?vue&type=script&lang=js&"
export * from "./rubric_from_template.vue?vue&type=script&lang=js&"
import style0 from "./rubric_from_template.vue?vue&type=style&index=0&id=225c3c31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c3c31",
  null
  
)

export default component.exports